var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.853 2.31062C9.26338 -0.371014 4.99015 -0.445603 2.30852 2.14402C-0.373116 4.73365 -0.447706 9.00687 2.14192 11.6885C4.73154 14.3701 9.00477 14.4447 11.6864 11.8551C14.368 9.26548 14.4426 4.99226 11.853 2.31062ZM7.6917 9.5022C7.68458 9.90964 7.34855 10.2341 6.94111 10.227C6.73741 10.2235 6.55443 10.1377 6.42326 10.0019C6.29209 9.86603 6.21274 9.68017 6.21629 9.47647L6.24687 7.7244L4.49483 7.69384C4.29113 7.69028 4.10815 7.60449 3.97698 7.46866C3.84581 7.33283 3.76646 7.14697 3.77001 6.94327C3.7771 6.53585 4.11316 6.21132 4.5206 6.21844L6.27267 6.24902L6.30325 4.49695C6.31036 4.08951 6.6464 3.765 7.05384 3.77212C7.46128 3.77923 7.78579 4.11527 7.77867 4.5227L7.74807 6.27475L9.50012 6.30531C9.90756 6.31242 10.2321 6.64846 10.225 7.0559C10.2179 7.46332 9.88181 7.78785 9.47437 7.78074L7.72228 7.75013L7.6917 9.5022Z",
    fill: "#7257F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.c9962c50c230a269c01ba0cf552aea5e.svg";
export { ForwardRef as ReactComponent };